import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
const AffiliateOverviewRoot = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="desktop:grid-cols-3 desktop:grid-rows-[auto_1fr] grid grid-cols-1 items-start gap-5">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AffiliateOverviewChart = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="desktop:col-span-2 min-w-0">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AffiliateOverviewAside = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="desktop:col-start-3 desktop:row-span-2 desktop:row-start-1 tablet:grid-cols-2 desktop:grid-cols-1 grid min-w-0 grid-cols-1 gap-5">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AffiliateOverviewSections = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="desktop:col-span-2 desktop:col-start-1 desktop:row-start-2 min-w-0">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const AffiliateOverview = {
  Root: AffiliateOverviewRoot,
  Chart: AffiliateOverviewChart,
  Aside: AffiliateOverviewAside,
  Sections: AffiliateOverviewSections
};